// import { createUseStyles } from 'react-jss'
import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'


export default css`
.layout {
  overflow: hidden;
  padding-top: ${sizes.header.desktop.height};
  background-color: ${colors.midnightExpress};
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  .layout {
    padding-top: ${sizes.header.mobile.height};
  }
}
`
